export enum SendMethodEnum {
	Email = 'Email',
	Sms = 'SMS',
}

export const SendMethodArray = [SendMethodEnum.Email, SendMethodEnum.Sms];
